import React, { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Avatar, Combobox, ComboboxItem } from '@node-space/ui-components'
import { useEarnSheetContext } from '../../context/EarnSheetProvider'

interface EarnSheetCurrencySelectProps {
  disabled?: boolean
}

export const EarnSheetCurrencySelect = ({ disabled = false }: EarnSheetCurrencySelectProps) => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const { earnProducts } = useEarnSheetContext()

  const currencyOptions = useMemo<ComboboxItem[]>(
    () =>
      earnProducts.map(asset => ({
        value: asset.asset,
        leftText: asset.asset,
        LeftElement: <Avatar type="currency" name={asset.asset} size="small" />,
      })),
    [earnProducts]
  )

  return (
    <Controller
      control={control}
      name="currency"
      render={({ field: { value, ...field }, fieldState: { error } }) => (
        <Combobox
          {...field}
          disabled={disabled}
          id="earn-currency"
          label={t('earn.depositSheet.currency')}
          selectPlaceholder={t('select')}
          items={currencyOptions}
          defaultValue={value}
          errorText={error?.message}
          testId="earn-currency-combobox"
        />
      )}
    />
  )
}
